import { makeAutoObservable, runInAction } from 'mobx';
import { IncomeCategorys, IncomeCategoryParams } from 'src/@types/Choqorak/Settings/IncomeCategory';
import agent from 'src/api/agent';
export default class IncomeCategoryStore {
  openDialog = false;

  IncomeCategoryRegistry = new Map<number, IncomeCategorys>();

  editMode = false; //When click on edit button

  selectedIncomeCategory: IncomeCategorys | undefined = undefined;

  totalRecord: number = 0;

  constructor() {
    makeAutoObservable(this);
  }

  get IncomeCategoryList() {
    return Array.from(this.IncomeCategoryRegistry.values());
  }

  setIncomeCategoryList = (IncomeCategory: IncomeCategorys) => {
    this.IncomeCategoryRegistry.set(IncomeCategory.id!, IncomeCategory);
  };

  //Pagination
  loadIncomeCategory = async (params: IncomeCategoryParams) => {
    // this.IncomeCategoryRegistry.clear();
    try {
      const result = await agent.IncomeCategory.getList(params);
      runInAction(() => {
        this.totalRecord = result.data.totalRecord;
        const reversed = result.data.data.reverse();
        reversed.forEach((lst: any) => {
          this.setIncomeCategoryList(lst);
        });
      });
    } catch (error) {
      console.log(error);
    }
  };

  // Search
  IncomeCategorySearch = async (params: IncomeCategoryParams) => {
    this.IncomeCategoryRegistry.clear();
    this.loadIncomeCategory(params);
  };

  getIncomeCategoryFromRegistry = (id: number) => {
    let IncomeCategory = this.IncomeCategoryRegistry.get(id);
    if (IncomeCategory) {
      this.editMode = true;
      this.selectedIncomeCategory = IncomeCategory;
    }
  };

  clearSelectedIncomeCategory = () => {
    this.editMode = false;
    this.selectedIncomeCategory = undefined;
  };

  deleteIncomeCategory = async (id: number, remark?: string) => {
    await agent.IncomeCategory.delete(id, remark!);
    runInAction(() => {
      this.IncomeCategoryRegistry.delete(id);
      this.totalRecord--;
      this.setOpenCloseDialog();
    });
  };

  setOpenCloseDialog = () => (this.openDialog = !this.openDialog);

  createIncomeCategory = async (IncomeCategory: IncomeCategorys) => {
    await agent.IncomeCategory.create(IncomeCategory);
    runInAction(() => {
      this.loadIncomeCategory({ pageIndex: 0, pageSize: 5 });
      this.clearSelectedIncomeCategory();
    });
  };

  updateIncomeCategory = async (IncomeCategory: IncomeCategorys) => {
    await agent.IncomeCategory.update(IncomeCategory);

    runInAction(() => {
      this.loadIncomeCategory({ pageIndex: 0, pageSize: 5 });
      this.IncomeCategoryRegistry.delete(IncomeCategory.id!);
      this.IncomeCategoryRegistry.set(IncomeCategory.id!, IncomeCategory);
      this.clearSelectedIncomeCategory();
    });
  };
}
